import React from "react";
import {
  CenterMobileGeneralPageBanner,
  CenterMobileGeneralPageGadgets,
  CenterMobileGeneralPageDescription,
  CenterMobileGeneralPageRepair,
  CenterMobileGeneralPageAdvantages,
  CenterMobileGeneralPageLinks,
  CenterMobileGeneralPageLinksMobile,
  CenterMobileGeneralPageFeedbacks,
  BreadCrumbs,
  Page,
} from "../../index";
import { useMedia } from "../../../utils/useMedia";
import centerMobileBanner from "../../../images/banners/center-mobile-general-banner.svg";
import { Helmet } from "react-helmet";

function LinksPages() {
  const isBreakpoint = useMedia("(max-width: 780px)");

  if (isBreakpoint) {
    return <CenterMobileGeneralPageLinksMobile />;
  }
  return <CenterMobileGeneralPageLinks />;
}

const CenterMobileGeneralPage = () => {
  return (
    <Page title="Oh!MyGadget! - ремонт смартфонов и планшетов">
      <main className="center-mobile__general-page">
        <Helmet>
          <link rel="canonical" href="https://ohmygadget.ru/center-mobile" />
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Профессиональный ремонт планшетов и смартфонов любых марок и моделей в сервисе Oh!MyGadget!. Современное оборудование и сертифицированные специалисты."
          />
        </Helmet>
        <CenterMobileGeneralPageBanner
          title="ПРОФЕССИОНАЛЬНЫЙ РЕМОНТ ГАДЖЕТОВ"
          banner={centerMobileBanner}
        />
        <BreadCrumbs />
        <CenterMobileGeneralPageGadgets />
        <CenterMobileGeneralPageDescription />
        <CenterMobileGeneralPageRepair />
        <CenterMobileGeneralPageAdvantages />
        <CenterMobileGeneralPageFeedbacks />
        {LinksPages()}
      </main>
    </Page>
  );
};

export default CenterMobileGeneralPage;
